import { Grid, MenuItem, TextField, Typography, Box, Button } from "@mui/material";
import { useSlideInContext } from "ui/SlideIn";
import { useManageModal } from "ui/Modal";
// import usePersonStore from "../../../store/personStore";
// import usePersonAuthStore, { decodedToken } from "../../../store/personAuthStore";
import { useEffect, useState } from "react";
import LoadingButton from "@mui/lab/LoadingButton";
import { SelectTriageCustomField, SelectSearchOption, SelectTriageDate } from "./components";
import { Location, LocationModel } from "ft-shared-graphql"
export type GetTriageRequest = {
    sessionDate?: Date | null,
    searchParam?: string | null,
    customfieldId?: string | null,
    category?: string | null
}
export type GetTriageProps = {
    defaultLocation: LocationModel
    onSubmit: (values: GetTriageRequest) => void
}
export default function GetTriage({ defaultLocation, onSubmit }: GetTriageProps) {
    const [formState, setFormState] = useState<{
        sessionDate: string | null;
        searchParam: string | null;
        customfieldId: string | null;
        category: string | null;
    }>({
        sessionDate: null,
        searchParam: null,
        customfieldId: null,
        category: null
    })

    const handleSelectSearchOption = (option: string) => {
        if (option != "launchDate") {
            setFormState((prevState) => ({
                ...prevState, category: "customfield", customfieldId: option
            }))
        } else {
            setFormState((prevState) => ({
                ...prevState, category: option
            }))
        }
    }
    const handleSelectDate = (date: string) => {
        setFormState((prevState) => ({
            ...prevState,
            sessionDate: date
        }))
    }
    const handleSearchCustom = (data: string) => {
        setFormState((prevState) => (
            {
                ...prevState,
                searchParam: data
            }
        ))
    }
    const handleSubmit = async () => {
        const { sessionDate, searchParam, customfieldId, category } = formState
        onSubmit({
            sessionDate: sessionDate != null ? new Date(sessionDate as string) : null,
            searchParam: searchParam,
            customfieldId: customfieldId,
            category: category
        })
    }

    return (
        <Grid container spacing={4}
            direction="column"
            alignItems="center"
        >
            <Grid size={12} direction="column" alignItems="center" textAlign="center">
                <Typography>Create a triage report for the students at {defaultLocation?.name}</Typography>
                <Typography>Triage will reflect all completed sessions</Typography>

            </Grid>
            <Grid size={12}>
                <SelectSearchOption defaultLocation={defaultLocation} onSelect={handleSelectSearchOption} />
            </Grid>
            {formState.category === "launchDate" ?
                <>
                    <SelectTriageDate onSelect={handleSelectDate} />
                    <Grid size={12} direction="column" alignItems="center">
                        <LoadingButton
                            variant="contained"
                            disabled={!formState.sessionDate}
                            onClick={handleSubmit}
                        >Confirm</LoadingButton>
                    </Grid>
                </>
                :
                formState.category === "customfield" ?
                    <>
                        <SelectTriageCustomField defaultLocation={defaultLocation} onChange={handleSearchCustom} customFieldId={formState.customfieldId} />
                        <Grid size={12} direction="column" alignItems="center">
                            <LoadingButton
                                variant="contained"
                                disabled={!formState.searchParam}
                                onClick={handleSubmit}
                            >Confirm</LoadingButton>
                        </Grid>
                    </>
                    : <></>}
        </Grid>
    )
}